// global
import { createStore, applyMiddleware } from 'redux';
import createHistory from 'history/createBrowserHistory';
// middlewares
import { routerMiddleware } from 'react-router-redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
// local
import reducers from './reducers';

// Create a history of your choosing (we're using a browser history in this case)
let history = createHistory();
// mount the middlewares
const middlewares = [];
middlewares.push(thunk);
middlewares.push(routerMiddleware(history));
// only add the log if running on development
if (process.env.NODE_ENV === 'development') {
    middlewares.push(createLogger({ collapsed: true, duration: true, diff: true }));
}
// Add the reducer to your store on the `router` key
// Also apply our middleware for navigating
const store = createStore(reducers, applyMiddleware(...middlewares));
// Create an enhanced history that syncs navigation events with the store
export { store, history };
